module.exports = __webpack_public_path__ + "img/van-blue.daa16738.svg";